import { createContext, useContext, useState, useEffect } from 'react';
import { makeBreakpoints, makeBreakpoint } from '@utils/css';
import { makeSizeTokens } from '@utils/react';

makeSizeTokens("--task");
const taskBreakpointsCls = "task--breakpoints";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const {
  range,
  ...baseTaskBreakpoints
} = makeBreakpoints({
  mobile: 0,
  tablet: 710,
  desktop: 924
});
const tinyTaskBreakpoint = makeBreakpoint(0, 290);

/**
 * Our tasks may live in multiple different containers that are not necessarily
 * as wide as the viewport of the users device.
 *
 * However, tasks are expected to be responsive relative to their bounding
 * container.
 *
 * As such we implement our custom task breakpoints that are relative to their
 * container.
 */
const TaskContainerContext = /*#__PURE__*/createContext({
  current: null
});
let hasMounted = false;
function useMatchTaskBreakpoint(breakpoint) {
  const ref = useContext(TaskContainerContext);
  const [matches, setMatches] = useState(hasMounted ? matchesTaskBreakpoint(ref, breakpoint) : false);
  useEffect(() => {
    hasMounted = true;
    setMatches(matchesTaskBreakpoint(ref, breakpoint));
    const target = ref.current;
    if (!target) {
      return;
    }
    const observer = new ResizeObserver(() => {
      setMatches(matchesTaskBreakpoint(ref, breakpoint));
    });
    observer.observe(target);
    return () => {
      observer.disconnect();
    };
  }, [breakpoint, ref]);
  return matches;
}
function matchesTaskBreakpoint(ref, breakpoint) {
  const width = ref.current?.clientWidth ?? window.innerWidth;
  return (!breakpoint.from || breakpoint.from <= width) && (!breakpoint.to || width <= breakpoint.to);
}
const taskBreakpoints = {
  tiny: tinyTaskBreakpoint,
  ...baseTaskBreakpoints
};

export { TaskContainerContext, taskBreakpoints, taskBreakpointsCls, useMatchTaskBreakpoint };
//# sourceMappingURL=hook.task-breakpoints.js.map
